import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { Store, createSelector } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { OneClickUpdateOrderAction } from '../../actions/one-click-orders.actions';
import { State } from '../../reducers';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import { getOneClickPurchaseOrderRequired } from '@ordersnproducts/modules/one-click-order/selectors/one-click-jobsite-sales-area.selector';
import { OneClickLoadValidatePurchaseOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-validate-purchase-order.actions';

const purchaseOrderData = createSelector(
  getOneClickPurchaseOrderRequired,
  getOneClickSelectedOrder,
  (purchaseOrderRequired, selectedOrder) => {
    return { purchaseOrderRequired, selectedOrder };
  },
);
@Injectable()
export class OneClickSetPurchaseOrder implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: string, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value !== null && value !== undefined) {
      this.store
        .select(purchaseOrderData)
        .pipe(take(1))
        .subscribe(({ purchaseOrderRequired, selectedOrder }) => {
          const orderUpdated: Order = {
            ...selectedOrder,
            purchaseOrder: value,
          };
          if (purchaseOrderRequired) {
            this.store.dispatch(new OneClickLoadValidatePurchaseOrderAction());
            this.store.dispatch(new OneClickUpdateOrderAction(orderUpdated));
          }
          this.store.dispatch(new OneClickUpdateOrderAction(orderUpdated));
        });
    }
  }
}
